/*
 * O estado da busca, compartilhado entre os menus (o do cabeçalho e o do
 * banner de boas-vindas): o termo, se a
 * busca já inclui os tópicos (depois do Enter) e os resultados.
 *
 * Digitar faz só a busca "rápida":
 * categorias, etiquetas e usuários, com 400ms de espera. Os tópicos entram
 * quando a pessoa pressiona Enter ou escolhe uma sugestão.
 *
 * Aqui fica só o que o campo desenha; a busca em si (engine.ts) desce com o
 * painel (SearchPanel), pedido no foco/hover do campo ou no ocioso do boot.
 */

import { withSearchPanel } from './panelLazy';
export class SearchMenuState {
  term = '';
  /** A busca já inclui os tópicos. */
  searchTopics = false;
  loading = false;
  invalidTerm = false;
  noResults = false;
  results = null;
  /** "#", "@" ou o atalho digitado ("é:"): o assistente aparece no lugar dos resultados. */
  suggestionKeyword = false;
  suggestionResults = [];

  /** Troca o termo da busca. */
  setTerm(term, opts = {}) {
    this.term = term.replace(/[​-‍﻿]/g, '');
    this.searchTopics = !!opts.searchTopics;
    this.trigger();
  }

  /** Enter: a mesma consulta, agora com os tópicos. */
  searchTopicsNow() {
    this.searchTopics = true;
    this.trigger();
  }
  clear() {
    this.setTerm('');
  }
  trigger() {
    this.noResults = false;
    // O carregando do Enter aparece já; o resto vem do motor (síncrono quando o chunk já chegou).
    this.loading = this.searchTopics;
    withSearchPanel(panel => panel.trigger(this));
  }
}
const state = new SearchMenuState();
export default state;
flarum.reg.add('ramon-canela', 'forum/search/state', state);